module.exports = __webpack_public_path__ + "static/media/Angela_Ferrari_03.d16b261a.jpg";